import { UPLOAD_URL } from '../constances/server'
import axios from 'axios'
export function uploadFile(file) {
  return axios.post(`${UPLOAD_URL}`, file, { headers: { 'Content-Type': 'multipart/form-data' }})
}
